package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.AspectRatio
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.lennycodes.hldi.constants.HLDITheme

val GalleryContainerStyle = CssStyle {
    base {
        Modifier
            .position(Position.Relative)
            .aspectRatio(AspectRatio.Auto)
            .overflow(Overflow.Hidden)
            .borderRadius(12.px)
            .cursor(Cursor.Pointer)
            .backgroundColor(HLDITheme.Colors.accent)
    }

    focusVisible {
        Modifier.outline(2.px, LineStyle.Solid, HLDITheme.Colors.accent)
    }

    cssRule(":hover img") {
        Modifier.scale(1.1)
    }

    cssRule(":hover div") {
        Modifier.opacity(1)
    }
}
val GalleryGridStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Grid)
            .styleModifier {
                property("grid-template-columns", "repeat(auto-fill, minmax(300px, 1fr))")
            }
            .gap(16.px)
    }
}

val LightboxOverlayStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .top(0.px).left(0.px).right(0.px).bottom(0.px)
            .backgroundColor(Color.rgba(0, 0, 0, 0.9f))
            .zIndex(2000)
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .padding(40.px)
            .cursor(Cursor.Pointer)
    }
}

val LightboxContentStyle = CssStyle {
    base {
        Modifier
            .maxWidth(90.percent)
            .maxHeight(90.vh)
            .position(Position.Relative)
            .cursor(Cursor.Default) // prevent inheriting the overlay's pointer cursor on the content itself
    }
}

val LightboxCloseButtonStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .top((-40).px)
            .right(0.px)
            .backgroundColor(HLDITheme.Colors.tranparent)
            .color(HLDITheme.Colors.white)
            .border(0.px)
            .fontSize(24.px)
            .cursor(Cursor.Pointer)
            .transition(
                Transition.of(
                    property = "opacity",
                    duration = 200.ms,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier.opacity(0.7)
    }

    focusVisible {
        Modifier.outline(2.px, LineStyle.Solid, HLDITheme.Colors.white)
    }
}

val LightboxImageStyle = CssStyle {
    base {
        Modifier
            .maxWidth(100.percent)
            .maxHeight(80.vh)
            .borderRadius(8.px)
            .objectFit(ObjectFit.Contain)
    }
}

val LightboxCaptionStyle = CssStyle {
    base {
        Modifier
            .color(HLDITheme.Colors.white)
            .textAlign(TextAlign.Center)

            .margin(top = 20.px)
    }
}